import { defineComponent as _defineComponent } from 'vue'
import { useValidatorsStore } from '@/store/validators.store.ts';

export type ValidatorsStatusLabelType = 'all' | 'active' | 'inactive' | 'staked';


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidatorsStatusLabel',
  props: {
    status: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const __returned__ = { props, get useValidatorsStore() { return useValidatorsStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})